(function(w, d) {
  var accessibleLangs = window.accessibleLangs;
  var autotranslateLanguages = window.autotranslateLanguages;
  
  var accessiblePages = ['/docs/', '/devlog/'];
  var notTranslateInterfaceForLangs = ['ru','zh'];
  var route = window.route;
  var isAccessiblePageToTranslate = false;

  for (var i = 0; i < accessiblePages.length; i++) {
    if (!isAccessiblePageToTranslate) {
      isAccessiblePageToTranslate = route.indexOf(accessiblePages[i]) == 0 || route === '/';
    }
  }

  $translateWarningEl = $('.js-translate-warning');
  $translateWarningCloseEl = $translateWarningEl.find('.js-translate-warning-close');
  $languageSelector = $('.js-hide-autotranslate-language');
  $translateNoList = $('.js-translate-no');

  var langSelector = {};

  var initTranslateConfig = {
    lang: 'en',
    currentPageLang: window.currentLang ? window.currentLang : 'en',
    active: false,
  };


  function yaTranslateSetLangActive(lang, isActive) {
    if (isActive === undefined) {
      isActive = true;
    }

    localStorage.setItem('yt-widget', JSON.stringify({
        'lang': lang,
        'active': isActive,
      })
    );
  }

  function yaTranslateGetLang() {
    if (localStorage['yt-widget'] !== undefined && JSON.parse(localStorage['yt-widget']).lang !== undefined) {
      return JSON.parse(localStorage['yt-widget']).lang
    }

    return initTranslateConfig.lang;
  }

  function yaTranslateGetActive() {
    if (localStorage['yt-widget'] !== undefined && JSON.parse(localStorage['yt-widget']).active !== undefined) {
      return JSON.parse(localStorage['yt-widget']).active
    }

    return initTranslateConfig.active;
  }

  function showTranslateWarning() {
    $translateWarningEl.removeClass('hide');
  }
  
  function hideTranslateWarning() {
    $translateWarningEl.addClass('hide');
  }

  function showAutotranslateSelectors() {
    $languageSelector.removeClass('hide-autotranslate-language');
  }

  function hideAutotranslateSelectors() {
    $languageSelector.addClass('hide-autotranslate-language');
  }

  function generateNewLocation(lang, isAutotranslateActive, yaLang) {
    var pathParts = window.location.pathname.split('/');

    var newLocation = '/' + lang + '/' + pathParts.slice(2).join('/');

    if (isAutotranslateActive) {
      newLocation += '?' + window.Unigine.setQueryParam('autotranslate', yaLang, window.location.search);
    } else {
      newLocation += window.Unigine.removeQueryParam('autotranslate', window.location.search);
    }

    if (window.location.hash) {
      newLocation += window.location.hash;
    }

    return newLocation
  }

  function setNewLocation(lang, isAutotranslateActive, yaLang) {
    var newLocation = generateNewLocation(lang, isAutotranslateActive, yaLang);

    window.location = newLocation;

    return false;
  }

  function addTranslateNo() {
    $translateNoList.each(function( index ) {
      $(this).attr( 'translate', 'no' );
    });
  }

  function removeTranslateNo() {
    $translateNoList.each(function( index ) {
      $(this).removeAttr( 'translate' );
    });
  }

  function initYaTranslator() {
    var script = document.createElement('script');
    script.src = 'https://translate.yandex.net/website-widget/v1/widget.js?widgetId=ytWidget&pageLang=' + initTranslateConfig.lang + '&widgetTheme=light&autoMode=false';
    document.getElementsByTagName('head')[0].appendChild(script);

    var code = yaTranslateGetLang();

    document.querySelector('.language-selector .js-current-language').innerHTML = '<i class="icon icon-flag-' + code + ' active" title="' + autotranslateLanguages[code] + '"></i>';
  }

  function init() {
    var $langLinksElems = $('.js-language-link');

    var langQueryParam = window.Unigine.getQueryParam('autotranslate');
    var isAccessibleLangToTranslate;
    var realLocaleOfPage = window.Unigine.getCookie('realLocaleOfPage');

    if (isAccessiblePageToTranslate) {
      showAutotranslateSelectors()
    } else {
      hideAutotranslateSelectors()
    }

    $translateWarningCloseEl.on('click', function(e){
      hideTranslateWarning();
      window.Unigine.setCookie('translateWarningHidden', 1, 5 * 24 * 60 * 60 * 1000);
    });

    if (langQueryParam) {
      yaTranslateSetLangActive(langQueryParam, true);
      window.Unigine.deleteCookie('translateWarningHidden');
      
      // if (initTranslateConfig.currentPageLang !== 'en') {
      //   setNewLocation(initTranslateConfig.lang, true, langQueryParam);
      // }
    }

    isAccessibleLangToTranslate = accessibleLangs.indexOf(yaTranslateGetLang()) !== -1;

    if (yaTranslateGetActive() && isAccessibleLangToTranslate && isAccessiblePageToTranslate) {
      var yaLang = yaTranslateGetLang();

      if (!langQueryParam) {
        var newLocation
        if (yaLang === 'zh') {
          newLocation = generateNewLocation('ch', true, yaLang);
        } else if (yaLang === 'ru') {
          newLocation = generateNewLocation('ru', true, yaLang);
        } else {
          newLocation = generateNewLocation(initTranslateConfig.lang, true, yaLang);
        }

        history.replaceState({}, '', newLocation);

        window.location.reload();
      }

      if (notTranslateInterfaceForLangs.indexOf(yaLang) !== -1) {
        addTranslateNo();
      }

      if (!window.langSelector.yaTranslateGetActive()) {
        $('#doc').attr('translate', 'no');
        window.Unigine.setCookie('translateWarningHidden', 1, 5 * 24 * 60 * 60 * 1000);
        hideTranslateWarning();
      } else {
        $('#doc').removeAttr('translate');
        window.Unigine.deleteCookie('translateWarningHidden');
        showTranslateWarning();
      }

      langSelector.initYaTranslator();

      if (!window.Unigine.getCookie('translateWarningHidden')) {
        showTranslateWarning();
      }
    }

    $langLinksElems.each(function() {
      $(this).on('click', function(e){
        e.preventDefault();

        var $clickedLinkEl = $(this);
        var linkLang = $clickedLinkEl.attr('data-lang');
        var yaLang = $clickedLinkEl.attr('data-ya-lang');

        if (yaLang && yaLang !== 'none') {
          yaTranslateSetLangActive(yaLang, true);
          window.Unigine.deleteCookie('translateWarningHidden');
          setNewLocation(linkLang, true, yaLang);
        } else {
          yaTranslateSetLangActive(linkLang, false);
          setNewLocation(linkLang, false);
        }
      });
    })
  };

  langSelector.initYaTranslator = initYaTranslator;
  langSelector.yaTranslateGetLang = yaTranslateGetLang;
  langSelector.yaTranslateGetActive = yaTranslateGetActive;
  langSelector.init  = init;

  w.langSelector = langSelector;

  $(function() {
    langSelector.init();
  });

})(window, document);


$(function() {

  var darkMode = window.Unigine.getCookie('darkMode');
  var $darkModeSwitchers = $('.js-dark-mode-switcher');
  var prefersDarkScheme = window.matchMedia("(prefers-color-scheme: dark)").matches;

  var addDarkModeStyleToWysiwygIframe = function() {
    setTimeout(function() {
      var body = $('.cke_wysiwyg_frame').contents().find('body');
      body.css('background-color', '#353A3F');
      body.css('color', '#C0C6CB');
    }, 300);
  };
  
  var addLightModeStylesToWysiwygIframe = function() {
    setTimeout(function() {
      var body = $('.cke_wysiwyg_frame').contents().find('body');
      body.css('background-color', '#fff');
      body.css('color', '#333');
    }, 300);
  };

  var enableDarkTheme = function() {
    $('html').addClass('dark-theme');
    $darkModeSwitchers.each(function(index, switcher) {
      $(switcher).prop('checked', true);
    });
  }

  var disableDarkTheme = function() {
    $('html').removeClass('dark-theme');
    $darkModeSwitchers.each(function(index, switcher) {
      $(switcher).prop('checked', false);
    });
  }

  if (!darkMode) {
    if (prefersDarkScheme) {
      window.Unigine.setCookie('darkMode', true);
    } else {
      window.Unigine.setCookie('darkMode', false);
    }
    darkMode = window.Unigine.getCookie('darkMode');
  }
  

  if (darkMode == 'true') {
    enableDarkTheme();
    addDarkModeStyleToWysiwygIframe();
  } else {
    disableDarkTheme();
    addLightModeStylesToWysiwygIframe();
  }
  
  
  $darkModeSwitchers.each(function(index, switcher) {
    $(switcher).on('change', function() {
      if ($(switcher).prop('checked')) {
        window.Unigine.setCookie('darkMode', true);
        enableDarkTheme();
        addDarkModeStyleToWysiwygIframe();
      } else {
        window.Unigine.setCookie('darkMode', false);
        disableDarkTheme();
        addLightModeStylesToWysiwygIframe();
      }
    });
  });
});
$(function() {
  var $modal = $('#more-language-modal');
  var $showBtn = $('#more-language-modal-show-btn');
  var $closeBtn = $('#more-language-modal-close-btn');


  $showBtn.on('click', function(e) {
    e.preventDefault();
    $modal.css('display', 'block');
  });
  
  $closeBtn.on('click', function() {
    $modal.css('display', 'none');
  });
  
  $(window).on('click', function(event) {
    if (event.target == $modal[0]) {
      $modal.css('display', 'none');
    }
  });
});
$(function() {
  var $showMoreContainers = $('.js-show-more-container');
  var $showMoreMenus = $('.js-show-more-menu');

  if ($showMoreContainers.length > 0) {
    $.each($showMoreContainers, function( index, showMoreContainer ) {
      $(showMoreContainer).find('.js-show-more-trigger').on('click', function() {
        if ($(this).next('.js-show-more-menu').hasClass('_show')) {
          $showMoreMenus.removeClass('_show');
          $(this).next('.js-show-more-menu').removeClass('_show');
        } else {
          $showMoreMenus.removeClass('_show');
          $(this).next('.js-show-more-menu').addClass('_show');
        }

      });
    });

    $(window).on('click', function(e) {
      if (!e.target.closest('.js-show-more-container')) {
        $showMoreMenus.removeClass('_show');
      }
    });
  }
});

$(function() {
  var $showAllUsersContainers = $('.js-show-all-users-container');
  var $showAllLicensesContainers = $('.js-show-all-licenses-container');

  if ($showAllUsersContainers.length > 0) {
    var $input = $showAllUsersContainers.find('input');

    $input.on('change', function() {
      if (this.checked) {
        window.Unigine.setCookie('showAllUsers', '1')
      } else {
        window.Unigine.setCookie('showAllUsers', '0')
      }

      location.reload();
    });
  }
  
  if ($showAllLicensesContainers.length > 0) {
    var $input = $showAllLicensesContainers.find('input');
    var $expiredLicenses = $('.js-licenses-container.expired');

    var hideExpiredLicenses = function() {
      $expiredLicenses.addClass('_hide')
    }

    var showExpiredLicenses = function() {
      $expiredLicenses.removeClass('_hide')
    }

    $input.on('change', function() {
      if (this.checked) {
        window.Unigine.setCookie('showAllLicenses', '1')
        showExpiredLicenses();
      } else {
        window.Unigine.setCookie('showAllLicenses', '0')
        hideExpiredLicenses();
      }
    });
  }
});
